<header class="header">
  <img [src]="baseUri + '/assets/aihobs-ecs/images/logo.svg'" alt="" />
</header>
<div class="container">
  <h1>パスワードの変更</h1>
  <p class="v-text">新しいパスワードを入力してください。</p>
  <form
    id="change-password-form"
    (submit)="submitChangePassword()"
    class="v-application--is-ltr"
  >
    <!-- Do not remove this.  This protects against CSRF vulnerabilities -->
    <!-- <input type="hidden" id="_csrf" name="_csrf" value="{{ csrf_token }}" />
          <input type="hidden" id="ticket" name="ticket" value="{{ ticket }}" />
          <input type="hidden" id="email" name="email" value="{{ email }}" /> -->

    <div
      class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
    >
      <div class="v-input__control">
        <app-aihobs-ecs-password-input
          [(ngModel)]="password"
          name="password"
          placeholder="パスワード"
          class="text-black-38"
        ></app-aihobs-ecs-password-input>
        <div _ngcontent-bwu-c24="" class="v-text-field__details">
          <div
            id="errorMessagePassword"
            _ngcontent-bwu-c24=""
            class="hidden v-messages theme--light error--text"
            *ngIf="errorMessages.password"
          >
            <div
              _ngcontent-bwu-c24=""
              class="v-messages__wrapper ng-star-inserted"
            >
              {{ errorMessages.password }}
            </div>
            <!---->
          </div>
          <div *ngIf="!errorMessages.password">
            <p class="v-text-caption">
              半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
    >
      <div class="v-input__control">
        <app-aihobs-ecs-password-input
          [(ngModel)]="confirmationPassword"
          name="confirm"
          placeholder="パスワード（再入力）"
        ></app-aihobs-ecs-password-input>
        <div _ngcontent-bwu-c24="" class="v-text-field__details">
          <div
            id="errorMessageConfirmPassword"
            _ngcontent-bwu-c24=""
            class="hidden v-messages theme--light error--text"
            *ngIf="errorMessages.confirmPassword"
          >
            <div
              _ngcontent-bwu-c24=""
              class="v-messages__wrapper ng-star-inserted"
            >
              {{ errorMessages.confirmPassword }}
            </div>
            <!---->
          </div>
          <div *ngIf="!errorMessages.confirmPassword">
            <p class="v-text-caption">
              パスワードを確認するために再入力してください
            </p>
          </div>
        </div>
      </div>
    </div>

    <div _ngcontent-ohw-c49="" class="text-center mb-5">
      <button
        _ngcontent-ohw-c49=""
        type="button"
        medium=""
        class="full-width primary-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
        (click)="submitChangePassword()"
      >
        <span _ngcontent-ohw-c49="" class="text-button-medium v-btn__content">
          設定する
        </span>
      </button>
    </div>
  </form>
  <!-- <footer class="footer">Copyright © DOCTORS Inc. All Rights Reserved.</footer> -->
</div>

<!-- <script src="https://cdn.auth0.com/js/change-password-1.5.min.js"></script> -->
